import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueMeta from "vue-meta";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueNumber from "vue-number-animation";
import i18n from "./i18n";

import "./custom.scss";

Vue.use(VueMeta);
Vue.use(BootstrapVue);
// Vue.use(IconsPlugin);
Vue.use(VueNumber);

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
  // mounted() {
  //   // You'll need this for renderAfterDocumentEvent.
  //   document.dispatchEvent(new Event("render-event"));
  // },
}).$mount("#app");
